// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"138":"profile","479":"locationmanagement","613":"taskmanagement","640":"devicemanagement","679":"InfoWindow","792":"main","837":"groupmanagement","893":"notifications","945":"dashboard","966":"login"}[chunkId] || chunkId) + ".css";
};